import { render, staticRenderFns } from "./menu-logo.vue?vue&type=template&id=65385283&scoped=true"
import script from "./menu-logo.vue?vue&type=script&lang=js"
export * from "./menu-logo.vue?vue&type=script&lang=js"
import style0 from "./menu-logo.vue?vue&type=style&index=0&id=65385283&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65385283",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65385283')) {
      api.createRecord('65385283', component.options)
    } else {
      api.reload('65385283', component.options)
    }
    module.hot.accept("./menu-logo.vue?vue&type=template&id=65385283&scoped=true", function () {
      api.rerender('65385283', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/draw-menu/components/menu-logo.vue"
export default component.exports